<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'grey'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.deactivate')"
        :icon="error ? 'mdi-alert' : 'mdi-power-plug-off'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnDeactivate',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>